import quoteCategories from '~/composables/constants/quoteCategories'
import CountriesEnum from '~/enums/CountriesEnum'
import getDefaultCountryId from '~/utils/countries/getDefaultCountryId'

interface QuoteCategoryInterface {
  slug: string
  hook: string
  icon: string
  label: string
}

export const useQuoteCategory = () => {
  const defaultCountryId = getDefaultCountryId()
  const { t } = useLang()

  const isEnabled = () => {
    return defaultCountryId === CountriesEnum.Lithuania
  }

  const getQuoteCategories = (): QuoteCategoryInterface[] => {
    const quoteCategoriesMap = []

    for (const prop in quoteCategories) {
      const quoteCategoryMap: QuoteCategoryInterface = {
        slug: prop,
        hook: quoteCategories[prop].hook,
        icon: quoteCategories[prop].icon,
        label: t(`pages.quotes.${prop.split('-').join('_')}.nav_title`),
      }

      quoteCategoriesMap.push(quoteCategoryMap)
    }

    return quoteCategoriesMap
  }

  return { isEnabled, getQuoteCategories }
}
